import Layout from '@/components/layout/Layout';

const PrivacyPolicy = () => {
  return (
    <Layout>
      <section className="relative pt-8 pb-12 bg-background overflow-hidden min-h-screen">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-accent/5 blur-[120px] z-0" />

        <div className="container-max max-w-4xl relative z-10 px-4">
          <span className="inline-block px-4 py-2 bg-accent/5 border border-accent/20 rounded-full text-accent-foreground text-[10px] font-black uppercase tracking-[0.2em] mb-8">
            Data Privacy
          </span>
          <h1 className="text-2xl md:text-4xl font-black text-primary mb-12 tracking-tighter uppercase">Privacy <br /><span className="text-gradient-gold">Policy</span></h1>

          <div className="card-premium !p-12 bg-white/40 border-white/60 backdrop-blur-xl">
            <div className="prose prose-lg max-w-none prose-headings:text-primary prose-headings:font-black prose-headings:uppercase prose-headings:tracking-tighter prose-p:text-muted-foreground prose-p:font-medium prose-p:leading-relaxed">
              <p className="text-sm font-black text-accent uppercase tracking-widest mb-12 pb-8 border-b border-gray-100">
                Last Updated: January 2024
              </p>

              <h2 className="text-2xl mb-6">Introduction</h2>
              <p>
                Ratchagan Analysis ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information when you visit our website or use our services.
              </p>

              <h2 className="text-2xl mt-12 mb-6">Information We Collect</h2>
              <p>We may collect the following types of information:</p>
              <ul className="list-none pl-0 space-y-4">
                <li className="flex gap-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                  <span><strong>Personal Information:</strong> Name, email address, phone number, and payment information when you register for our courses.</span>
                </li>
                <li className="flex gap-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                  <span><strong>Usage Data:</strong> Information about how you interact with our website and services.</span>
                </li>
                <li className="flex gap-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                  <span><strong>Device Information:</strong> Browser type, IP address, and operating system.</span>
                </li>
              </ul>

              <h2 className="text-2xl mt-12 mb-6">How We Use Your Information</h2>
              <p>We use the collected information for the following purposes:</p>
              <ul className="list-none pl-0 space-y-4">
                <li className="flex gap-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                  <span>To provide and maintain our services</span>
                </li>
                <li className="flex gap-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                  <span>To process your course enrollments and payments</span>
                </li>
                <li className="flex gap-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                  <span>To send you important updates and communications</span>
                </li>
                <li className="flex gap-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                  <span>To improve our website and services</span>
                </li>
              </ul>

              <h2 className="text-2xl mt-12 mb-6">Data Security</h2>
              <p>
                We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
              </p>

              <h2 className="text-2xl mt-12 mb-6">Third-Party Services</h2>
              <p>
                We may use third-party services such as payment processors (Razorpay) to process transactions. These services have their own privacy policies governing the use of your information.
              </p>

              <div className="mt-16 pt-12 border-t border-gray-100 italic">
                <p className="text-sm">
                  If you have any questions about your data, please email us at{' '}
                  <a href="mailto:ratchagananalysis@gmail.com" className="text-accent font-bold hover:underline">
                    ratchagananalysis@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPolicy;
